var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-label-audit" }, [
    _c(
      "div",
      { staticClass: "standard-size-16 color-gray-10" },
      [
        _c(
          "yxtf-row",
          {
            staticClass: "mv24 font-normal font-size-14",
            attrs: { type: "flex" },
          },
          [
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_sp_employee" /** 员工 */)) + "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  { attrs: { "open-filter": true, placement: "top" } },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("yxtbiz-user-name", {
                          attrs: { name: _vm.detail.fullname },
                        }),
                        _c("span", [
                          _vm._v(_vm._s("（" + _vm.detail.username + "）")),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "yxtbiz-label-audit_ellipsis" },
                      [
                        _c("yxtbiz-user-name", {
                          attrs: { name: _vm.detail.fullname || "" },
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.detail.username,
                                expression: "detail.username",
                              },
                            ],
                          },
                          [_vm._v(_vm._s("（" + _vm.detail.username + "）"))]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(_vm._s(_vm.$t("pc_biz_sp_label" /**  标签 */)) + "："),
                ]),
                _c(
                  "yxtf-tooltip",
                  {
                    attrs: {
                      "open-filter": true,
                      content: _vm.detail.labelName,
                      placement: "top",
                    },
                  },
                  [
                    _c("div", { staticClass: "yxtbiz-label-audit_ellipsis" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.detail.labelName || "--") +
                          "\n          "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "yxtf-row",
          {
            staticClass: "mv24 font-normal font-size-14",
            attrs: { type: "flex" },
          },
          [
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 24 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_sp_addLabelValue" /**新增标签值 */)) +
                      "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  {
                    attrs: {
                      "open-filter": true,
                      content: _vm.detail.addLabelValue,
                      placement: "top",
                    },
                  },
                  [
                    _c("div", { staticClass: "yxtbiz-label-audit_ellipsis" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.detail.addLabelValue || "--") +
                          "\n          "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "yxtf-row",
          {
            staticClass: "mv24 font-normal font-size-14",
            attrs: { type: "flex" },
          },
          [
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 24 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("pc_biz_sp_removeLabelValue" /**移除标签值 */)
                    ) + "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  {
                    attrs: {
                      "open-filter": true,
                      content: _vm.detail.removeLabelValue,
                      placement: "top",
                    },
                  },
                  [
                    _c("div", { staticClass: "yxtbiz-label-audit_ellipsis" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.detail.removeLabelValue || "--") +
                          "\n          "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }